import script from "./Tag.vue?vue&type=script&setup=true&lang=js"
export * from "./Tag.vue?vue&type=script&setup=true&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=2eb6dbf0&lang=css"

const __exports__ = script;

export default __exports__